import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./CustomSelect.css";

const CustomSelect = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  optionLabelKey = "label",
  optionValueKey = "value",
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (option) => {
    onChange(option);
    setOpen(false);
  };

  const filteredOptions = options.filter((opt) => {
    const label = opt[optionLabelKey];
    if (!label || typeof label !== "string") return true;
    return !label.toLowerCase().includes("none");
  });

  const dropdownOptions = filteredOptions.filter(
    (opt) => opt.type !== "placeholder"
  );

  const selectedOption = options.find(
    (opt) => opt[optionValueKey] === value
  );

  const displayText = (() => {
    if (!selectedOption) return placeholder;

    const label = selectedOption[optionLabelKey];
    if (!label || typeof label !== "string") return placeholder;

    if (label.toLowerCase().includes("none")) return placeholder;

    return label;
  })();

  const textClassName =
    selectedOption && displayText !== placeholder ? "selected" : "placeholder";

  return (
    <div className="custom-select-wrapper">
      <label className="custom-select-label">{label}</label>

      <div
        className={`custom-select-input ${disabled ? "disabled" : ""}`}
        onClick={() => !disabled && setOpen((prev) => !prev)}
      >
        <span className={textClassName}>{displayText}</span>

        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          className={open ? "rotated" : ""}
        >
          <path
            d="M6 9l6 6 6-6"
            stroke="#9A99AB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <AnimatePresence>
        {open && !disabled && (
          <motion.div
            className="custom-select-dropdown"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.15 }}
          >
            {dropdownOptions.map((opt) => {
              const isTextOnly =
                opt.type === "header" ||
                opt.type === "no_services" ||
                opt.type === "no_listings";

              // 🟡 TEXT ONLY WITH LINES
              if (isTextOnly) {
                return (
                  <div
                    key={opt[optionValueKey]}
                    className="custom-select-text"
                  >
                    <span className="custom-select-text-label">
                      {opt[optionLabelKey]}
                    </span>
                  </div>
                );
              }

              return (
                <div
                  key={opt[optionValueKey]}
                  className={`custom-select-option ${
                    value === opt[optionValueKey] ? "selected" : ""
                  } ${opt.disabled ? "disabled" : ""}`}
                  onClick={() => !opt.disabled && handleSelect(opt)}
                >
                  <span className="option-label">
                    {opt[optionLabelKey]}
                  </span>
                  <span
                    className={`radio-circle ${
                      value === opt[optionValueKey] ? "active" : ""
                    }`}
                  />
                </div>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CustomSelect;
